import { useLingui } from "@lingui/react/macro";
import { formatCurrency } from "@offstreetparking/design-system/formatters";
import { type SummaryProps, formatDeductionDate } from "../paymentScheduleSummary";
import { FirstDeductionRow, NumberOfDeductionsRow } from "./DeductionRows";
import { PerPeriodAmount } from "./PerPeriodAmount";
import { SummaryRow } from "./SummaryRow";

export const FiniteSummaryRows = ({ overview, locale, currency }: SummaryProps) => {
	const { t } = useLingui();

	return (
		<>
			<SummaryRow
				label={t`Total permit cost`}
				value={formatCurrency({ locale, valueInCents: overview.deductedTotalInCents, currency })}
			/>
			<SummaryRow
				label={t`Per pay period`}
				value={<PerPeriodAmount overview={overview} locale={locale} currency={currency} />}
			/>
			<NumberOfDeductionsRow overview={overview} locale={locale} />
			<FirstDeductionRow overview={overview} />
			{overview.lastDeductionDate && (
				<SummaryRow label={t`Final deduction`} value={formatDeductionDate(overview.lastDeductionDate)} />
			)}
		</>
	);
};
